import React from 'react';

const LoadingPS = () => {
  return (
    <div className="ps-loading">
      <img className="ps-loading-icon" src="/img/loader-circle.svg" alt="" />
      <span>Carregando...</span>
    </div>
  );
};

export default LoadingPS;
